import { Type } from '@angular/core'

import { IFilterAngularComp } from 'ag-grid-angular'

import {
  CustomFilterType,
  FilterOptions,
  FilterType,
  TaskManagerSetupOptions,
  View,
} from '@flowx/core-sdk'

import { BooleanFilterComponent } from './components/boolean-filter/boolean-filter.component'
import { SelectFilterComponent } from './components/select-filter/select-filter.component'

export const TASK_EVENTS_UPDATE_DELAY = 5000

export interface TaskManagerInputs {
  initConfig: TaskManagerSetupOptions
  view?: View
  viewResourceDefinitionId?: string
}

export const ANGULAR_CUSTOM_AG_GRID_FILTER_TYPE: Record<
  CustomFilterType,
  FilterOptions<Type<IFilterAngularComp>>['filter']
> = {
  [FilterType.booleanType]: BooleanFilterComponent,
  [FilterType.enumType]: SelectFilterComponent,
}
